/* @flow */
import React, {PureComponent} from 'react'
import {Provider} from 'react-redux'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {push} from 'react-router-redux'
import {Route, Switch} from 'react-router-dom'
import {ConnectedRouter} from 'react-router-redux'
import I18n from 'I18n'

import history from './createHistory'
import store from './configureStore'
import {fetchTokenFromStorage} from 'modules/Authenticate/actions'
import {webURL} from 'modules/Common/constants'

import styles from './AppViewContainer.module.scss'
import AdminHeader from './Admin/containers/HeaderContainer'
import AdminMainContainer from './AdminMainContainer'
import AdminNavSide from 'modules/Admin/containers/NavSideContainer'
import LoginAdmin from './Admin/containers/LoginContainer'

import type {MapDispatchToProps} from 'react-redux'

type DispatchProps = {
  fetchTokenFromStorage: typeof fetchTokenFromStorage
};

const mapDispatchToProps: MapDispatchToProps<{}, {}, DispatchProps> = dispatch => {
  return bindActionCreators(
    {
      fetchTokenFromStorage
    },
    dispatch
  )
}

type Props = DispatchProps;

export class AppContainer extends PureComponent<Props, void> {
  componentWillMount() {
    this.props.fetchTokenFromStorage()
  }

  componentDidMount() {
    if (!store.getState().authentication.accessToken) {
      store.dispatch(push(webURL.landing.loginAdmin))
    }
    const lang = localStorage.getItem('lang')
    if (lang) {
      I18n.setLanguage(lang)
    }
  }

  render() {
    return (
      <div className={styles['admin-container']}>
        <AdminHeader history={history} location={store.getState().router.location} />
        <div className={styles.container}>
          <AdminNavSide location={store.getState().router.location} />
          <AdminMainContainer />
        </div>
      </div>
    )
  }
}

AppContainer = connect(null, mapDispatchToProps)(AppContainer)

export class AppViewContainer extends PureComponent<any, void> {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route exact path={webURL.landing.loginAdmin} component={LoginAdmin} />
            <Route path='' component={AppContainer} />
          </Switch>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default AppViewContainer
